// @flow

import type { FullState } from '../../../types';

export const selectSource = (state: FullState): string =>
  state.domainSuggest.source;
